var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoNewsletter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "78px",
    height: "70px",
    viewBox: "0 0 78 70",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun_newsletter_1429109",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.3933333,0 L14.56,0 L14.56,29.3243243 L0.693333333,29.3243243 L0.693333333,59.5945946 C0.693333333,65.3413413 4.96155205,70 10.2266667,70 L66.1266667,70 C72.3490748,70 77.3933333,64.4943125 77.3933333,57.7027027 L77.3933333,0 Z M14.56,59.5945946 C14.56,62.2067522 12.6199006,64.3243243 10.2266667,64.3243243 C7.83343275,64.3243243 5.89333333,62.2067522 5.89333333,59.5945946 L5.89333333,35 L14.56,35 L14.56,59.5945946 Z M72.1933333,57.7027027 C72.1933333,61.3597233 69.4771941,64.3243243 66.1266667,64.3243243 L18.6333333,64.3243243 C19.320617,62.8608336 19.677205,61.2391364 19.6733333,59.5945946 L19.6733333,5.67567568 L72.1933333,5.67567568 L72.1933333,57.7027027 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.6333333,11.8243243 L25.5666667,11.8243243 L25.5666667,31.6891892 L44.6333333,31.6891892 L44.6333333,11.8243243 Z M39.4333333,26.0135135 L30.7666667,26.0135135 L30.7666667,17.5 L39.4333333,17.5 L39.4333333,26.0135135 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 48.9666667,
    y: 14.6621622,
    width: 17.3333333,
    height: 5.67567568
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 48.9666667,
    y: 26.0135135,
    width: 17.3333333,
    height: 5.67567568
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 25.5666667,
    y: 38.3108108,
    width: 40.7333333,
    height: 5.67567568
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 25.5666667,
    y: 49.6621622,
    width: 40.7333333,
    height: 5.67567568
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoNewsletter);
export default __webpack_public_path__ + "static/media/ico-newsletter.56828a271449671f78a64a478e076831.svg";
export { ForwardRef as ReactComponent };